import { hoursToMilliseconds } from "date-fns";
import { getTimeMs } from "TimeHelper";
import { Match, matchHasData } from "./Match";

const MATCH_UNKNOWN_THRESHOLD = hoursToMilliseconds(4);
export type MatchStatus =
  | "Completed"
  | "Delayed"
  | "Live"
  | "Unknown"
  | "Upcoming";

export const getMatchStatus = (match: Match): MatchStatus => {
  if (match.isDelayed) {
    return "Delayed";
  }

  if (match.isComplete) {
    return "Completed";
  }

  if (!considerMatchLiveOrUpcoming(match.startTimeMs)) {
    return "Unknown";
  }

  return matchHasStarted(match) ? "Live" : "Upcoming";
};

export const matchHasStarted = (match: Match) => {
  const currentTimeMs = getTimeMs();
  if (match.startTimeMs <= currentTimeMs) {
    return true;
  }

  return matchHasData(match);
};

export const considerMatchLiveOrUpcoming = (startTimeMs: number) => {
  return startTimeMs + MATCH_UNKNOWN_THRESHOLD > getTimeMs();
};
